<div class="user-management-result">
  <div class="container-fluid">
    <div class="bg-white p-3 mt-2">
      <div class="row">
        <div class="col-md-5 col-sm-12">
          <h4>
            Notification Types
            <!--<i class="fa fa-spinner fa-spin" *ngIf="isLoader"></i>-->
          </h4>
        </div>
        <div class="col-md-7 col-sm-12 text-end">
          <div class="row g-3 flex justify-content-end">
            <div class="col-auto">
              <app-search-box placeholder="Search..."
                              (searchChange)="applyFilter($event)">
              </app-search-box>
            </div>
          </div>
        </div>
      </div>

      <div class="table-responsive data-grid mt-4 sticky-header-table sticky-header-table-height-xlg full-height" #tableTypes>
        <table [dataSource]="dataSource"
               mat-table
               class="table table-hover"
               infiniteScroll
               [infiniteScrollDistance]="1"
               [infiniteScrollThrottle]="20"
               [infiniteScrollContainer]="tableTypes"
               [fromRoot]="true"
               (scrolled)="onTableScroll()"
               [trackBy]="trackById" matSort>


          <ng-container matColumnDef="name">
            <th mat-header-cell
                class="col-2 cursor-pointer"
                *matHeaderCellDef mat-sort-header>
              Name <i class="fa fa-sort ms-1"></i>
            </th>
            <td mat-cell *matCellDef="let element">
              {{ element.name }}
            </td>
          </ng-container>

          <ng-container matColumnDef="description">
            <th mat-header-cell
                class="col-2 cursor-pointer"
                *matHeaderCellDef mat-sort-header>
              Description <i class="fa fa-sort ms-1"></i>
            </th>
            <td mat-cell *matCellDef="let element">
              {{ element.description }}
            </td>
          </ng-container>

          <ng-container matColumnDef="notificationMethod">
            <th mat-header-cell
                class="col-1 cursor-pointer"
                *matHeaderCellDef mat-sort-header>
              Group <i class="fa fa-sort ms-1"></i>
            </th>
            <td mat-cell *matCellDef="let element">
              {{ element.notificationGroupName }}
            </td>
          </ng-container>

          <ng-container matColumnDef="defaultEmailSubject">
            <th mat-header-cell
                class="col-2 cursor-pointer"
                *matHeaderCellDef mat-sort-header>
              Email Subject <i class="fa fa-sort ms-1"></i>
            </th>
            <td mat-cell *matCellDef="let element">
              {{ element.defaultEmailSubject }}
            </td>
          </ng-container>

          <ng-container matColumnDef="defaultSMSText">
            <th mat-header-cell
                class="col-2 cursor-pointer "
                *matHeaderCellDef mat-sort-header>
              SMS Text <i class="fa fa-sort ms-1"></i>
            </th>
            <td mat-cell *matCellDef="let element">
              {{ element.defaultSMSText }}
            </td>
          </ng-container>

          <ng-container matColumnDef="tagLegend">
            <th mat-header-cell
                class="col-2 cursor-pointer "
                *matHeaderCellDef mat-sort-header>
              Tags <i class="fa fa-sort ms-1"></i>
            </th>
            <td mat-cell *matCellDef="let element">
              {{ element.tagLegend }}
            </td>
          </ng-container>





          <ng-container matColumnDef="action">
            <th mat-header-cell
                class="action-heading col-1"
                *matHeaderCellDef></th>
            <td mat-cell
                *matCellDef="let element"
                ngbDropdown
                placement="start">

              <a href="javascript:void(0)" (click)="goToEdit(element)" class="btn btn-outline-primary"> <i class="fa fa-edit"></i></a>

            </td>
          </ng-container>

          <tr mat-header-row *matHeaderRowDef="displayedColumns$.value; sticky: true"></tr>
          <tr mat-row
              *matRowDef="
        let row;
        columns: displayedColumns$.value;
        let saleIndex = index
      "
              class="border-start-0 border-end-0 pointer pt-2"></tr>
        </table>

        <!--<div class="col-md-12 text-center" *ngIf="isLoader">
    Loading <i class="fa fa-spinner fa-spin"></i>
  </div>-->
      </div>
    </div>
  </div>
</div>
